module.exports = __webpack_public_path__ + "img/qualite_acaplast_01.d6a3f6b5.jpg";